import React, { Component } from "react";
import { connect } from "react-redux";
import * as sessionActions from "../../../../Redux/actions/sessionActions";
import { bindActionCreators } from "redux";
import Modal from "../../../utils/customModal";
import {
  customDecode,
  getLogoutURL,
  loadingHtml,
} from "../../../utils/functions";
import { ReactTitle } from "react-meta-tags";
import { getEnvironment } from "../../../../Redux/reducer/env";
import querystring from "querystring";

export class Redirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      content: null,
      modalMessage: "Redireccionando",
      hideModal: undefined,
    };
  }

  componentDidMount() {
    return this.redirectUser();
  }

  redirectUser = () => {
    var saml = window.__SAML__;

    if (undefined == saml) {
      return this.props.history.push("/landing");
    }

    saml = JSON.parse(saml);
    delete window.__SAML__;

    const { login } = this.props.actions;
    this.setState({
      modal: true,
      content: loadingHtml(),
      hideModal: undefined,
    });

    return login({
      codUser: saml.SAMLResponse,
      access: null,
      country: "PA",
      typeUser: "CSA",
      codToken: "RFToken",
    })
      .then((response) => {
        var data = response.data.data;
        this.setState({ modal: false });
        const user = customDecode(data.jwt).user_type;

        switch (user) {
          case "PRO":
            return this.props.history.push("/providerSite/dashboard");
          case "CSA":
            return this.props.history.push("/dashboard");
          case "CASH":
            return this.props.history.push("/bscadministrator/home");
          case "CASC":
            return this.props.history.push("/bscadministrator/home");
          case "BSC":
            return this.props.history.push("/bscadministrator/home");
        }
        return true;
      })
      .catch(() => {
        this.setState({ modal: false });
        // Deslogueamos de LeapCMS y redirigimos
        const env = querystring.escape(this.props.env);
        var url = getLogoutURL(env);

        if (url !== "") {
          window.location = url;
        } else {
          return this.props.history.push("/landing");
        }
        // var buttons = {
        //   continueBtn: {
        //     action: () => this.setState({ modal: false }),
        //     text: "Volver a intentar",
        //   },
        // };

        // var title = "Credenciales incorrectas";
        // var message = "Usuario o contraseña incorrecta.";
        // switch (err.response.status) {
        //   case 409:
        //     title = "Sesión activa";
        //     message =
        //       "Este usuario posee una sesión activa, por favor intentar más tarde.";
        //     break;
        // }
        // // Errores de autenticación en caso de fallos del servicio

        // this.setState({
        //   modal: true,
        //   content: errorContainer(title, message, buttons),
        //   hideModal: () => this.setState({ modal: false }),
        // });
        // return false;
      });
  };

  render() {
    return (
      <div className="wrapper-login clients-login-background">
        <ReactTitle title={`Inicio de sesion - Reverse Factoring`} />
        <Modal show={this.state.modal} handleClose={this.state.hideModal}>
          {this.state.content}
        </Modal>
      </div>
    );
  }
}

const mapState = (state) => ({
  env: getEnvironment(state),
});

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};

export default connect(mapState, mapDispatch)(Redirect);
